function NotificationBubble() {
  return <div className="absolute -top-0.5 -right-0.5 size-2 rounded-full bg-callout-hotpink border-border-base border-1" aria-hidden="true" />;
}

export { NotificationBubble };
